import styled from '@emotion/styled';
import { useRef, useContext } from 'react';
import { useFocusRing, useRadio, VisuallyHidden, mergeProps, useId } from 'react-aria';

import { mergeRefs } from '../../../lib/mergeRefs';
import { TextMedium } from '../../common/text/TextMedium';
import { TextSmall } from '../../common/text/TextSmall';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

import { RadioContext } from './RadioGroup';
import { RadioIndicator } from './RadioIndicator';

export function DescriptionRadio(props) {
  const radioRef = useRef();
  const context = useContext(RadioContext);
  const radio = useRadio({ ...props, children: props.description }, context.state, radioRef);
  const focusRing = useFocusRing();

  const isSelected = context.state.selectedValue === props.value;

  const { ref: registerRef, ...registerProps } =
    context.register?.(context.name, {
      required: props.required,
    }) ?? {};

  const titleId = useId();
  const descriptionId = useId();

  return (
    <S.Label data-is-selected={isSelected}>
      <VisuallyHidden>
        <input
          {...mergeProps(radio.inputProps, focusRing.focusProps, registerProps)}
          ref={mergeRefs([registerRef, radioRef])}
          aria-labelledby={titleId}
          aria-describedby={descriptionId}
        />
      </VisuallyHidden>

      <S.CirleContainer>
        <RadioIndicator isSelected={isSelected} isFocusVisible={focusRing.isFocusVisible} />
      </S.CirleContainer>

      <div>
        <S.Title id={titleId}>{props.title}</S.Title>

        <S.Description id={descriptionId} color={theme.color.text_light}>
          {props.description}
        </S.Description>
      </div>
    </S.Label>
  );
}

function S() {}
DescriptionRadio.S = S;

S.Label = styled.label`
  position: relative;
  display: flex;
  padding: ${su(1, 2)};
  cursor: pointer;

  &:not(:last-of-type):after {
    content: '';
    position: absolute;
    bottom: 0;
    left: ${su(6)};
    right: 0;
    height: 1px;
    background: ${theme.color.line};
  }
`;

S.Title = styled(TextMedium)`
  margin-bottom: ${su(1)};
`;

S.Description = styled(TextSmall)`
  margin-bottom: ${su(1)};
`;

S.CirleContainer = styled.div`
  padding-inline-end: ${su(1)};
`;
